import * as ko from 'knockout';
import * as _ from 'underscore';
import * as $ from 'jquery';
import { Event } from 'Core/Common/Event';
import { EVENTS } from 'Core/ProfilePage/ProfileCard/Events/Events';
import { Modal } from 'Core/Common/Modal';
import { BlockUI } from 'Core/Common/BlockUi';
import { UserVarsManager } from 'Core/UserVarsManager/UserVarsManager';
import { Notifier } from 'Core/Common/Notifier';
import { ProfileCardModel } from 'Core/ProfilePage/ProfileCard/Models/ProfileCardModel';
import { ProfilePasswordModel } from 'Core/ProfilePage/ProfileCard/Models/ProfilePasswordModel';
import {
	ProfileCardViewModel,
	ProfileData,
	PasswordData
} from 'Core/ProfilePage/ProfileCard/Models/ProfileCardViewModel';
import { ProfileCardStore } from 'Core/ProfilePage/ProfileCard/Stores/ProfileCardStore';
import {PASSWORD} from 'Core/Constant';
import { NOTIFICATIONS, LABELS } from "Core/Components/Translation/Locales";
import ProfileCardTemplate from 'Core/ProfilePage/ProfileCard/Templates/ProfileCard.html';
ko.templates['Core/ProfilePage/ProfileCard/Templates/ProfileCard'] = ProfileCardTemplate;

export class ProfileCard extends Event {
	private _modal: Modal;
	private _model: KnockoutObservable<ProfileCardViewModel>;
	private _labels = LABELS;
	_el: HTMLElement;
	private _toggleCurrentPassword: KnockoutObservable<boolean>;
	private _toggleNewPassword: KnockoutObservable<boolean>;
	private _toggleRetypeNewPassword: KnockoutObservable<boolean>;
	private _userImage: KnockoutObservable<string>

	constructor() {
		super();
		this._model = ko.observable(null);
		this._el = null;
		this.AddEvent("IMAGE_CLICKED");
		this._toggleCurrentPassword = ko.observable(false);
		this._toggleNewPassword = ko.observable(false);
		this._toggleRetypeNewPassword = ko.observable(false);
		this._userImage = ko.observable(this.GetDefaultUserImage());
	}

	Init() {

		BlockUI.Block({ Target: this._el });
		var self = this;
		ProfileCardStore.Get()
			.always(() => {
				BlockUI.Unblock(this._el);
			})
			.then(profileCardModel => self.Setup(profileCardModel));
	}

	RenderByTargetId(target: string): void {
		ko.cleanNode(document.getElementById(target));
		ko.applyBindings(this, document.getElementById(target));
	}

	GetTemplateName() {
		return 'Core/ProfilePage/ProfileCard/Templates/ProfileCard';
	}

	AfterRender(el: Array<HTMLElement>) {
		this._el = el[0];
		this.Init();
	}

	Setup(model: ProfileCardModel) {
		let viewModel = new ProfileCardViewModel();
		viewModel.ProfileData = model ? this.MapProfileData(model) : null;
		viewModel.PasswordData = new PasswordData();

		this._model(viewModel);
	}


	Validate(model: ProfilePasswordModel, retypeNewPassword: string) {
		var self = this;

		if (!model.CurrentPassword || model.CurrentPassword === '') {
			new Notifier().Warning(NOTIFICATIONS.CURRENT_PASSWORD_IS_REQUIRED);
			return false;
		}

		if (!model.NewPassword || model.NewPassword === '') {
			new Notifier().Warning(NOTIFICATIONS.NEW_PASSWORD_IS_REQUIRED);
			return false;
		}

		if (model.NewPassword && model.NewPassword.length < PASSWORD.MinimumLength) {
			let passwordValidationMessage = NOTIFICATIONS.INCORECT_PASSWORD_LENGTH.replace('{MinimumLength}', PASSWORD.MinimumLength.toString());
			new Notifier().Warning(passwordValidationMessage);
			return false;
		}

		if (model.NewPassword !== retypeNewPassword) {
			new Notifier().Warning(NOTIFICATIONS.RE_TYPE_PASSWORD_NOT_MATCH);
			return false;
		}

		return true;
	};

	TogglePassword(toggle){
		toggle(!toggle());
	}

	SaveButtonClicked() {
		let passwordModel = new ProfilePasswordModel();
		var self = this;

		const passwordData = this._model().PasswordData;
		passwordModel.NewPassword = passwordData.NewPassword();
		passwordModel.CurrentPassword = passwordData.CurrentPassword();

		if (this.Validate(passwordModel, passwordData.RetypeNewPassword()) === false) {
			return;
		}

		ProfileCardStore.ChangePassword(passwordModel).then(result => {
			if (result.IsSuccessfull) {
				new Notifier().Success(NOTIFICATIONS.PASSWORD_CHANGED);
			}
			else {
				new Notifier().Failed(result.ErrorMessage);
			}
		});
	}

	ProfileImageClicked() {
		this.Trigger(EVENTS.IMAGE_CLICKED);
	}

	private MapProfileData(model: ProfileCardModel): ProfileData {
		const profileData = new ProfileData();

		profileData.FirstName = model.FirstName;
		profileData.MiddleName = model.MiddleName;
		profileData.Name = model.Name;
		profileData.UserId = model.UserId;
		profileData.AvatarData = model.AvatarData;

		return profileData;
	}

	GetDefaultUserImage(): string {
		return "data:image/jpeg;base64,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";
	}

	//UserProfile.prototype.SavePersonalSettings = (function () {

	//	var self = this;

	//	var requestModel = {
	//		FirstName: this.$firstNameInput.val(),
	//		MiddleName: this.$middleNameInput.val()
	//	}

	//	$.ajax({
	//		url: ApiUrl.UpdateProfile,
	//		type: 'POST',
	//		data: requestModel
	//	}).success(function (result) {
	//		if (result.IsSuccessfull) {
	//			self._notifier.Success('Profile updated');
	//			$(".profile-usertitle-name").html(requestModel.FirstName + ' ' + requestModel.MiddleName);
	//		}
	//	});

	//	var userVarsManager = new UserVarsManager();
	//	var data = { userVars: JSON.stringify(userVarsManager.GetAll()) }
	//	$.ajax({
	//		url: ApiUrl.UpdateUserVariables,
	//		type: 'POST',
	//		data: data
	//	}).success(function (result) {
	//		if (result.IsSuccessfull) {
	//			self._notifier.Success('User variables updated');
	//		}
	//	});
	//});
} 